import {
  ContactFragment,
  OptionalYearDateFragment,
  RelatedContactFragment,
} from '../generated/graphql'

const isOptionalYearDateFragment = (
  fragment: any, // eslint-disable-line @typescript-eslint/no-explicit-any
): fragment is OptionalYearDateFragment =>
  fragment &&
  fragment.__typename === 'OptionalYearDate' &&
  typeof fragment.day === 'number' &&
  typeof fragment.month === 'number' &&
  (fragment.year === null || typeof fragment.year === 'number')

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isContactFragment = (fragment: any): fragment is ContactFragment =>
  fragment &&
  fragment.__typename === 'Contact' &&
  typeof fragment.id === 'string' &&
  typeof fragment.firstName === 'string' &&
  typeof fragment.lastName === 'string' &&
  typeof fragment.address1 === 'string' &&
  typeof fragment.address2 === 'string' &&
  typeof fragment.company === 'string' &&
  typeof fragment.city === 'string' &&
  typeof fragment.state === 'string' &&
  typeof fragment.postalCode === 'string' &&
  (fragment.country === null || typeof fragment.country === 'string') &&
  typeof fragment.isPrimary === 'boolean' &&
  (fragment.birthday === null ||
    (isOptionalYearDateFragment(fragment.birthday) as boolean)) &&
  (fragment.anniversary === null ||
    (isOptionalYearDateFragment(fragment.anniversary) as boolean)) &&
  (fragment.contactRequest === null ||
    (fragment.contactRequest &&
      typeof fragment.contactRequest.id === 'string' &&
      (fragment.contactRequest.status === 'PENDING' ||
        fragment.contactRequest.status === 'COMPLETED' ||
        fragment.contactRequest.status === 'EXPIRED') &&
      typeof fragment.contactRequest.token === 'string' &&
      typeof fragment.contactRequest.expiresAt === 'string'))

export const isRelatedContactFragment = (
  fragment: any, // eslint-disable-line @typescript-eslint/no-explicit-any
): fragment is RelatedContactFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.firstName === 'string' &&
  typeof fragment.lastName === 'string' &&
  typeof fragment.address1 === 'string' &&
  typeof fragment.address2 === 'string' &&
  typeof fragment.company === 'string' &&
  typeof fragment.city === 'string' &&
  typeof fragment.state === 'string' &&
  typeof fragment.postalCode === 'string' &&
  (fragment.country === null || typeof fragment.country === 'string') &&
  typeof fragment.isPrimary === 'boolean' &&
  (fragment.birthday === null ||
    (isOptionalYearDateFragment(fragment.birthday) as boolean)) &&
  (fragment.anniversary === null ||
    (isOptionalYearDateFragment(fragment.anniversary) as boolean)) &&
  (fragment.homePhone === null || typeof fragment.homePhone === 'string') &&
  (fragment.cellPhone === null || typeof fragment.cellPhone === 'string') &&
  (fragment.workPhone === null || typeof fragment.workPhone === 'string') &&
  (fragment.faxNumber === null || typeof fragment.faxNumber === 'string') &&
  typeof fragment.website === 'string' &&
  (fragment.emailAddress === null || typeof fragment.emailAddress === 'string')
